import React from 'react';
import './Skeleton.css';

const Skeleton = ({ width = '100%', height = '1rem', circle = false, style = {}, className = '' }) => {
  const mergedStyle = {
    width,
    height,
    borderRadius: circle ? '9999px' : '8px',
    ...style
  };
  return <div className={`skeleton ${className}`} style={mergedStyle} />;
};

export default Skeleton;


